
import React,{useState, useEffect} from 'react';

import { Link } from "react-router-dom";
import '../sidebar.css'
import { Table ,Container} from 'react-bootstrap';
import AddInput from './AddInput';
import axios from 'axios';
import {Configs} from '../api';

const AdminTable =()=>{





return ( 

<Container className="table-cont">
<AddInput/>

</Container>


);
}


export default AdminTable;